import * as React from 'react';

// Utils
import { t } from '@toolkit/util/i18n';
import { FLEXLANE_COVERAGE, getFlexLaneCoverage } from '@src/shared/src/util/flexlane';
// Models
import { BasketItemModel } from '@src/shared/src/models';
// Styles
import '../styles/FlexLaneOptOut.scss';

type Props = {
  basketItems:BasketItemModel[];
};

const FALLBACKS:Record<FLEXLANE_COVERAGE, string> = {
  [FLEXLANE_COVERAGE.FLIGHT_AND_HOTEL]: 'Flight and hotel',
  [FLEXLANE_COVERAGE.FLIGHT_ONLY]: 'Flight only',
  [FLEXLANE_COVERAGE.HOTEL_ONLY]: 'Hotel only',
  [FLEXLANE_COVERAGE.ALL_ITEMS]: 'All items',
  [FLEXLANE_COVERAGE.REMOVED]: 'Removed',
};

export const FlexLaneCoverageSummary:React.FC<Props> = ({ basketItems }) => {
  const coverage = getFlexLaneCoverage(basketItems);

  if (!coverage) {
    return null;
  }

  return (
    <div className="lp-flexlane-summary">
      <div className="lp-flexlane-summary-label">
        {t('flexLaneOptOut.summary.label', { defaultValue: 'FlexLane' })}
      </div>
      <div className="lp-flexlane-summary-value">
        {t(`flexLaneOptOut.summary.${coverage}`, { defaultValue: FALLBACKS[coverage] })}
      </div>
    </div>
  );
};
